import AppDispatcher from '../dispatcher/AppDispatcher';
import {
  REQUEST_UPDATE_PREFERENCES,
  REQUEST_UPDATE_PREFERENCES_SUCCESS,
  REQUEST_UPDATE_PREFERENCES_ERROR,
  SET_PREFERENCE_UPDATE_STATUS,
  SET_MODE,
  SET_PREFERENCES,
} from '../constants/PreferencesConstants';

class PreferenceActionCreator {
  updatePreferences(preferences) {
    AppDispatcher.handleViewAction({
      actionType: REQUEST_UPDATE_PREFERENCES,
      data: preferences,
    });
  }

  handleUpdatePreferencesSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: REQUEST_UPDATE_PREFERENCES_SUCCESS,
      data: response,
    });
  }

  handleUpdatePreferencesError(response) {
    AppDispatcher.handleServerAction({
      actionType: REQUEST_UPDATE_PREFERENCES_ERROR,
      data: response,
    });
  }

  setUpdateStatus(status) {
    AppDispatcher.handleViewAction({
      actionType: SET_PREFERENCE_UPDATE_STATUS,
      data: status,
    });
  }

  setMode(mode) {
    AppDispatcher.handleViewAction({
      actionType: SET_MODE,
      data: mode,
    });
  }

  setPreferences(preferences) {
    AppDispatcher.handleViewAction({
      actionType: SET_PREFERENCES,
      data: preferences,
    });
  }
}

export default new PreferenceActionCreator();
